import styled from 'styled-components';
import { YoutubeSection } from '../../../../../components/common/video/YoutubeSection';
import { IProduct } from '../../../../../interfaces/Product.interfaces';
import { SecitionDivideLine } from './SecitionDivideLine';
import { SectionTitle } from './SectionTitle';

interface ProductYoutubeSectionProps {
  product: IProduct;
}

export const ProductYoutubeSection = ({ product }: ProductYoutubeSectionProps) => {
  return (
    <>
      <Container>
        <SectionTitle>{'생생한 동영상 리뷰'}</SectionTitle>
        <YoutubeSection youtubeUrl={product.youtubeUrl} />
      </Container>

      <SecitionDivideLine />
    </>
  );
};

const Container = styled.div`
  display: flex;
  padding: 32px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;
